import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import SidebarHeader from "./sub/SidebarHeader";
import MenuItem from "./sub/MenuItem";
import SupportBraincrea from "./sub/SupportBraincrea";

interface SidebarProps {
  isMobileOpen: boolean;
  onMobileClose: () => void;
}

const menuSections = [
  {
    title: "Principale",
    items: [
      { name: "Tableau de bord", icon: "LayoutDashboard", path: "/user/dashboard/home" },
      // { name: "Notifications", icon: "Bell", path: "/user/dashboard/notifications" },
    ],
  },
  {
    title: "Mes achats",
    items: [
      { name: "Mes commandes", icon: "ShoppingCart", path: "/user/dashboard/orders" },
      { name: "Mes produits", icon: "Package", path: "/user/dashboard/products" },
      { name: "Mes paiements", icon: "CreditCard", path: "/user/dashboard/payments" },
    ],
  },
  {
    title: "Mon compte",
    items: [
      { name: "Profil", icon: "User", path: "/user/dashboard/profile" },
      { name: "Sécurité", icon: "Shield", path: "/user/dashboard/security" },
    ],
  },
];

const Sidebar: React.FC<SidebarProps> = ({ isMobileOpen, onMobileClose }) => {
  return (
    <>
      {/* Overlay mobile */}
      <AnimatePresence>
        {isMobileOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onMobileClose}
            className="fixed inset-0 z-40 bg-black/70 backdrop-blur-sm lg:hidden"
          />
        )}
      </AnimatePresence>

      <aside
        className={`
          fixed lg:sticky top-0 left-0 z-50 h-full w-[280px] 
          transition-transform duration-300 ease-in-out
          ${isMobileOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}
        `}
      >
        <div
          className="relative h-full flex flex-col bg-dark/95 backdrop-blur-md border-t-8 border-l-8 border-secondary rounded-2xl"
          style={{
            boxShadow: `
              0 25px 50px -12px rgba(0, 0, 0, 0.5),
              0 0 0 1px rgba(2, 202, 253, 0.1) inset,
              0 0 15px rgba(22, 241, 158, 0.2),
              20px 0 30px -15px rgba(0, 0, 0, 0.6),
              -5px 0 15px -5px rgba(2, 202, 253, 0.3)
            `,
          }}
        >
          {/* Header fixe en haut */}
          <div className="flex-shrink-0 px-5 pt-6">
            <SidebarHeader />
          </div>

          {/* Zone de navigation scrollable */}
          <div className="flex-1 overflow-y-auto px-5 pb-2 persoscrollbar scrollbar-thin scrollbar-thumb-white/10">
            <nav className="mt-6 space-y-4">
              {menuSections.map((section, idx) => (
                <div key={idx} className="relative">
                  <h3 className="text-xs font-semibold uppercase tracking-wider text-gray-400 mb-1">
                    {section.title}
                  </h3>
                  <div className="relative ml-2">
                    <div className="absolute left-0 top-0 bottom-0 w-px bg-white/50" />
                    <div className="space-y-1">
                      {section.items.map((item) => (
                        <div key={item.name} className="relative">
                          <div className="absolute left-0 top-1/2 w-3 h-px bg-white/50" />
                          <div className="pl-4">
                            <MenuItem item={item} onMobileClose={onMobileClose} />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </nav>
          </div>

          {/* Support client fixé en bas */}
          <div className="flex-shrink-0 px-5 pb-6 pt-2">
            <SupportBraincrea />
          </div>
        </div>

        {/* Bouton fermeture mobile */}
        <button
          onClick={onMobileClose}
          className="lg:hidden absolute top-4 right-4 z-50 bg-white/50 backdrop-blur p-2 rounded-full text-white hover:bg-white/20 hover:scale-105 transition-all duration-200 shadow-lg"
        >
          <X size={20} />
        </button>
      </aside>
    </>
  );
};

export default Sidebar;